// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PhoneIncomingIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M19 12V7a1 1 0 0 1 2 0v2.586l4.293-4.294a1 1 0 0 1 1.415 1.415L22.415 11H25a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1Zm9.985 9.885A7.032 7.032 0 0 1 22 28c-9.925 0-18-8.075-18-18a7.03 7.03 0 0 1 6.115-6.984 2 2 0 0 1 2.078 1.189l2.64 5.894v.015a2 2 0 0 1-.16 1.886 1.367 1.367 0 0 1-.07.096L12 15.181c.936 1.903 2.926 3.875 4.854 4.814l3.042-2.589c.03-.025.061-.048.094-.07a2 2 0 0 1 1.896-.175l.017.008 5.888 2.639a2 2 0 0 1 1.194 2.077ZM27 21.635h-.014l-5.875-2.631-3.044 2.588a.85.85 0 0 1-.092.07 2 2 0 0 1-1.969.143c-2.341-1.131-4.675-3.447-5.807-5.764a2 2 0 0 1 .125-1.962.776.776 0 0 1 .071-.097L13 10.895l-2.625-5.875v-.015A5.025 5.025 0 0 0 6 10a16.018 16.018 0 0 0 16 16 5.026 5.026 0 0 0 5-4.366v.001Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
